import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/core/services/login.service';
import { ToastService } from 'src/app/core/toast.service';
import { BasicInfoTabService } from 'src/app/modules/dashboard/modules/my-directory/services/basic-info-tab.service';
import { EmployeeProfilesService } from 'src/app/modules/jobseek/services/employeeProfiles.service';
import { PostnewJob } from '../../services/job-section.service';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { log, timeStamp } from 'node:console';
@Component({
  selector: 'app-talent-listing',
  templateUrl: './talent-listing.component.html',
  styleUrls: ['./talent-listing.component.scss'],
})
export class TalentListingComponent implements OnInit {
  loginDetails: any;


  openAccordionId: string | null = null;
  displayMessage: any[] = [];
  newMessage: string = '';
  EditedMessageId: string = '';
  directory: any;
  openEnquiryAccordionId: string | null = null;
  enquiryData: any[];
  myEnquiryAllList: any;
  enquirystatus: any;

  // Filter Admin

  currentAdminTab = 'ALL';
  tabAdminCounts: any = {};
  limitAdmin = 10;
  offsetAdmin = 0;
  endOfDataAdmin = false;
  talentListAdmin: any[] = [];
  loadingAdmin = false;
  OpenFilterAdmin = false;

  roleOptionsAdmin: string[] = [];
  statusOptionsAdmin: string[] = [];
  empTypeOptionsAdmin: string[] = ['Full Time', 'Part Time', 'Casual', 'Contractor', 'Temporary Contractor', 'Locum'];

  //  sugggestions option Admin
  allEmpTypesAdminSuggest: string[] = ['Full Time', 'Part Time', 'Casual', 'Contractor', 'Temporary Contractor', 'Locum'];
  allRolesAdminSuggest: string[] = [];
  allStatusAdminSuggest: string[] = [];


  // Filter supplier , Practice

  currentUserTab = 'ALL';
  tabUserCounts: any = {};
  limitUser = 10;
  offsetUser = 0;
  endOfDataUser = false;
  hiringListUser: any[] = [];
  loadingUser = false;
  OpenFilterUser = false;

  roleOptionsUser: string[] = [];
  statusOptionsUser: string[] = [];
  empTypeOptionsUser: string[] = ['Full Time', 'Part Time', 'Casual', 'Contractor', 'Temporary Contractor', 'Locum'];

  //  suggestions option user
  roleOptionsUserSuggest: string[] = [];
  statusOptionsUserSuggest: string[] = [];
  empTypeOptionsUserSuggest: string[] = ['Full Time', 'Part Time', 'Casual', 'Contractor', 'Temporary Contractor', 'Locum'];

  // End filter 


  constructor(
    private basicInfoTabService: BasicInfoTabService,
    private loginService: LoginService,
    private toast: ToastService,
    private router: Router,
    private jobService: PostnewJob
  ) { }

  ngOnInit(): void {
    this.loginDetails = this.loginService.getLoginData();

    // if (this.loginDetails.type == 'SUPPLIER') {
    //   this.basicInfoTabService
    //     .userSupDirectory(this.loginDetails.id)
    //     .subscribe((data) => {
    //       this.directory = data[0];
    //     });
    // }

    // start new talent

    if (this.loginDetails.type === 'ADMIN') {

      this.loadAdminTabCounts();
      this.loadMoreAdminTalent();
    }

    if (this.loginDetails.type === 'SUPPLIER' || this.loginDetails.type === 'PRACTICE') {

      this.loadHiringTabCounts();
      this.loadMoreHiringList();

    }

    // End new talent

  }


  navigateToProfile(id: string): void {
    this.router.navigate(['/jobseek/talentis-details', id]);
  }

  cancelRequest(status: string, talentId: string) {
    this.jobService.updateHireTalentApproveStatus(talentId, status).subscribe({
      next: (res) => {
        if (res) {
          this.toast.openSnackBar('Talent cancelled successfully');
          this.offsetUser = 0;
          this.endOfDataUser = false;
          this.hiringListUser = [];
          this.loadHiringTabCounts();
          this.loadMoreHiringList();
        }
      },
      error: (err) => {
        console.error('Failed to update job status:', err);
      },
    });
  }




  messageAcordion(jobs: any): void {
    this.openEnquiryAccordionId = null;
    this.openAccordionId = this.openAccordionId === jobs.id ? null : jobs.id;
    this.newMessage = '';
    this.displayMessage = [];

    console.log("message accordion >>>", jobs);

    this.getAllTalentMessage(jobs?.id, jobs?.talent_enquiries_find_supplier?.id || jobs?.talent_enquiries_find_practice?.id);

  }

  getAllTalentMessage(HireId: any, EnquiryId: any) {
    console.log('jobIds', HireId, 'FromId', EnquiryId);

    this.jobService.getTalentMessage(HireId, EnquiryId).subscribe((data) => {
      this.displayMessage = data;
      console.log('message >>>', data);
    });
  }


  sendMessage(jobs: any): void {
    console.log("jobs >>>end message ", jobs);

    if (!this.newMessage.trim()) return; // Do not send empty messages


    const messages = {
      message: this.newMessage,
      talent_message_id_to: jobs?.id,
      message_from: this.loginDetails.id,
      talent_id: jobs?.job_profiles_id,
    };

    this.jobService.addTalentMessage(messages);

    this.newMessage = ''; // Clear the input box
  }

  deleteMessage(messageId: string): void {
    this.jobService
      .deleteTalentMessage(messageId)
      .then(() => { })
      .catch((err) => {
        console.error('Error deleting message:', err);
      });
  }

  editMessage(message: any): void {
    this.newMessage = message.message;
    this.EditedMessageId = message.id;
  }

  UpdateMessage(editId: any): void {
    const UpdateMessage = {
      id: editId,
      message: this.newMessage,
      updated_at: new Date().toISOString().replace('Z', '+00:00'),
    };

    this.jobService
      .editTalentMessages(
        UpdateMessage.id,
        UpdateMessage.message,
        UpdateMessage.updated_at
      )
      .then(() => {
        this.EditedMessageId = '';
        this.newMessage = '';
      });
  }


  //  Enquiry Accordion
  EnquiryAcoordion(jobs: any): void {
    // Close the message accordion when opening the enquiry accordion
    this.openAccordionId = null;
    this.enquiryData = [];

    this.openEnquiryAccordionId =
      this.openEnquiryAccordionId === jobs.id ? null : jobs.id;

    const jobID = jobs?.job_profiles_id;
    const userId = jobs?.dental_supplier_id || jobs?.dental_practice_id;

    this.jobService.getTalentEnquiry(jobID, userId).subscribe((data) => {
      this.enquiryData = data;
      console.log('enquiry data >>>>', data);
    });

  }


  // new filter Admin tab  status : ------------------------------------------

  onAdminTabChange(tab: string): void {
    this.currentAdminTab = tab;

    this.offsetAdmin = 0;
    this.endOfDataAdmin = false
    this.talentListAdmin = [];
    // this.loadingAdmin = false;
    this.loadMoreAdminTalent();
  }

  getAdminStatusForTab(tab: string): {
    admin_status?: string;
    active_status?: string;
  } {
    switch (tab) {

      case 'APPROVE':
        return { admin_status: 'APPROVE' };
      // return { admin_status: 'APPROVE', active_status: 'ACTIVE' };
      case 'REJECT':
        return { admin_status: 'REJECT' };
      case 'PENDING':
        return { admin_status: 'PENDING' };
      default:
        return {}; // All
    }
  }


  // 

  profession_type: '';
  admin_status: '';
  work_type: '';


  loadMoreAdminTalent(): void {

    if (this.loadingAdmin || this.endOfDataAdmin) return;

    this.loadingAdmin = true;

    const { admin_status, active_status } = this.getAdminStatusForTab(
      this.currentAdminTab
    );

    this.jobService
      .getFilterTalent(
        this.limitAdmin,
        this.offsetAdmin,
        admin_status,
        active_status,
        this.profession_type,
        this.admin_status,
        this.work_type

      )
      .subscribe((res: any) => {
        const newAdminTalent = res?.data?.job_profiles || [];

        if (newAdminTalent.length < this.limitAdmin) {
          this.endOfDataAdmin = true;
        }

        this.talentListAdmin = [...this.talentListAdmin, ...newAdminTalent];


        this.offsetAdmin += this.limitAdmin;
        this.loadingAdmin = false;
      });
  }


  loadAdminTabCounts(): void {
    this.jobService.getTalentAdminTabCounts().subscribe((res: any) => {

      this.tabAdminCounts = {
        ALL: res?.data?.all?.aggregate?.count || 0,
        PENDING: res?.data?.pending?.aggregate?.count || 0,
        APPROVE: res?.data?.approve?.aggregate?.count || 0,
        REJECTED: res?.data?.rejected?.aggregate?.count || 0,
      };
    });
  }
  // loadAdminTabCounts(): void {
  //   this.jobService.getTalentAdminTabCounts().subscribe((res: any) => {
  //     const nodes = res?.nodes || [];

  //     this.tabAdminCounts = {
  //       ALL: nodes.length,
  //       PENDING: nodes.filter(n => n.admin_status === 'PENDING').length,
  //       APPROVE: nodes.filter(n => n.admin_status === 'APPROVE').length,
  //       REJECTED: nodes.filter(n => n.admin_status === 'REJECT').length
  //     };
  //   });
  // }

  refreshAdminTabData(): void {

    this.offsetAdmin = 0;
    this.endOfDataAdmin = false;
    this.talentListAdmin = [];
    this.loadMoreAdminTalent();
  }



  // approve talentlist Admin

  changeStatusTalent(adminStatus: string, talentId: string): void {
    this.jobService.updateTalentStatus(talentId, adminStatus).subscribe({
      next: () => {

        if (adminStatus === "APPROVE") {
          this.toast.openSnackBar('Talent approved successfully');
        }
        else {
          this.toast.openSnackBar('Talent rejected successfully');
        }
        this.refreshAdminTabData(); // Refresh if needed
        this.loadAdminTabCounts();
      },
      error: (err) => {
        console.error('Failed to approve Talent:', err);
      }
    });
  }



  // admin talent Filter 

  filterToggleAdmin(): void {

    this.loadFilterAdminDropdownOptions();
    this.OpenFilterAdmin = !this.OpenFilterAdmin;
  }


  // admin talent filter

  loadFilterAdminDropdownOptions(): void {

    const where: any = {};

    if (this.loginDetails?.type === 'ADMIN') {
      where._and = [
        { admin_status: { _neq: 'DRAFT' } },
        { admin_status: { _neq: 'EXPIRED' } }
      ];
    }

    this.jobService.getUniqueFilterOptions(where).subscribe((result) => {
      this.statusOptionsAdmin = result.admin_status;
      this.roleOptionsAdmin = result.profession_types;


      this.allStatusAdminSuggest = result.admin_status;
      this.allRolesAdminSuggest = result.profession_types;

    });


  }


  onAdminFilterChange(): void {
    this.offsetAdmin = 0;
    this.endOfDataAdmin = false;
    this.talentListAdmin = [];
    this.loadMoreAdminTalent();
  }



  // clear filter 

  clearAllAdminFilters() {
    const isAlreadyCleared =
      !this.profession_type?.trim() &&
      !this.admin_status?.trim() &&
      !this.work_type?.trim();

    if (isAlreadyCleared) {
      this.loadMoreAdminTalent();
      this.endOfDataAdmin = false;

      return;
    }
    this.profession_type = '';
    this.admin_status = '';
    this.work_type = '';
    this.offsetAdmin = 0;
    this.endOfDataAdmin = false;
    this.talentListAdmin = [];
    this.loadMoreAdminTalent();
  }



  suggestionAdmin(search: string, source: string[], target: 'roleOptionsAdmin' | 'statusOptionsAdmin' | 'empTypeOptionsAdmin') {
    const query = search.trim().toLowerCase();
    this[target] = !query
      ? [...source]
      : source.filter(item => item.toLowerCase().includes(query));
  }

  suggestionUser(search: string, source: string[], target: 'roleOptionsUser' | 'statusOptionsUser' | 'empTypeOptionsUser') {
    const query = search.trim().toLowerCase();
    this[target] = !query
      ? [...source]
      : source.filter(item => item.toLowerCase().includes(query));
  }
  //  -------------

  // User New Supplier and Practice


  onUserTabChange(tab: string): void {
    this.currentUserTab = tab;

    this.offsetUser = 0;
    this.endOfDataUser = false
    this.hiringListUser = [];
    // this.loadingAdmin = false;
    this.loadMoreHiringList();
    this.openAccordionId = null;
    this.openEnquiryAccordionId = null;
  }

  getHiringStatusForTab(tab: string): {
    hiring_status?: string;
  } {
    switch (tab) {

      case 'APPROVE':
        return { hiring_status: 'APPROVE' };
      case 'REJECT':
        return { hiring_status: 'REJECT' };
      case 'PENDING':
        return { hiring_status: 'PENDING' };
      case 'CANCELLED':
        return { hiring_status: 'CANCELLED' };
      // case 'ENQUIRY':
      //   return { enquiry_Id: this.loginDetails.id };
      default:
        return {}; // All
    }
  }


  profession_type_user: '';
  hiring_status_user: '';
  work_type_user: '';

  loadMoreHiringList(): void {

    if (this.loadingUser || this.endOfDataUser) return;

    this.loadingUser = true;

    const { hiring_status } = this.getHiringStatusForTab(
      this.currentUserTab
    );


    this.jobService
      .getFilterHiringTalent(
        this.limitUser,
        this.offsetUser,
        hiring_status,
        this.profession_type_user,
        this.hiring_status_user,
        this.work_type_user,
      )
      .subscribe((res: any) => {
        const newHiringList = res?.data?.jobhirings || [];

        if (newHiringList.length < this.limitUser) {
          this.endOfDataUser = true;
        }

        this.hiringListUser = [...this.hiringListUser, ...newHiringList];
        this.offsetUser += this.limitUser;
        this.loadingUser = false;
      });
  }



  // Hiring Talent count

  loadHiringTabCounts(): void {
    this.jobService.getHiringTalentTabCounts().subscribe((res: any) => {

      this.tabUserCounts = {
        ALL: res?.data?.all?.aggregate?.count || 0,
        PENDING: res?.data?.pending?.aggregate?.count || 0,
        APPROVE: res?.data?.approve?.aggregate?.count || 0,
        REJECTED: res?.data?.rejected?.aggregate?.count || 0,
        CANCELLED: res?.data?.cancelled?.aggregate?.count || 0,
      };
    });
  }


  // filter talent hiring list

  // admin talent Filter 

  filterToggleUser(): void {

    this.loadFilterUserDropdownOptions();
    this.OpenFilterUser = !this.OpenFilterUser;
  }


  // components/your-component.ts
  loadFilterUserDropdownOptions(): void {

    // This filter applies ONLY to job_profiles table
    const whereProfiles: any = {
      admin_status: { _neq: 'DRAFT' }
    };

    this.jobService.getHiringFilterOptions(whereProfiles).subscribe((result) => {
      this.statusOptionsUser = result.hiring_status;
      this.roleOptionsUser = result.profession_types;

      // suhggest
      this.statusOptionsUserSuggest = result.hiring_status;
      this.roleOptionsUserSuggest = result.profession_types;

    });
  }




  onUserFilterChange(): void {
    this.offsetUser = 0;
    this.endOfDataUser = false;
    this.hiringListUser = [];
    this.loadMoreHiringList();
  }


  // clear filter talent hiring

  clearAllUserFilters() {
    const isAlreadyCleared =
      !this.profession_type_user?.trim() &&
      !this.hiring_status_user?.trim() &&
      !this.work_type_user?.trim();

    if (isAlreadyCleared) {
      this.loadMoreHiringList();
      this.endOfDataUser = false;

      return;
    }
    this.profession_type_user = '';
    this.hiring_status_user = '';
    this.work_type_user = '';
    this.offsetUser = 0;
    this.endOfDataUser = false;
    this.hiringListUser = [];
    this.loadMoreHiringList();
  }


  trackByJobId(index: number, talent: any): string {

    return talent.id;
  }



}
